export default class APIConfig {
    static isProductionServer = process.env.NODE_ENV === 'production'
    static isDevelopmentServer = process.env.NODE_ENV === 'development'

    static hostFor(hostname) {
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'http://localhost:9514'
        }
        if (hostname.startsWith('192.168.')) {
            return 'http://' + hostname + ':9514'
        }
        if (hostname === 'dev-erp.biiu.com.tw') {
            return 'https://dev-erp.biiu.com.tw/9514'
        }
        if (hostname === 'erp.biiu.com.tw' || APIConfig.isProductionServer) {
            return 'https://erp.biiu.com.tw/9513'
        }
        if (APIConfig.isDevelopmentServer) {
            return 'https://dev-erp.biiu.com.tw/9514'
        }
        return 'http://localhost:9514'
    }

    static Host = APIConfig.hostFor(window.location.hostname)
    static BPIURL = APIConfig.Host + '/bpi'
    static APIURL = APIConfig.Host + '/api'
}
